import { lazy } from 'react';
const EvaluationRoutes = [
    {
        label: '引用测评',
        key: 'reference',
        show: true,
        path: '/evaluation-reference',
        element: lazy(() => import('@/page/Evaluation/questionnaire/reference'))
    },
    {
        label: '公开测评',
        key: 'public',
        show: true,
        path: '/public/evaluation-public',
        element: lazy(() => import('@/page/Evaluation/questionnaire/public'))
    },
    {
        label: '测评报告',
        key: 'report',
        show: true,
        path: '/evaluation-report',
        element: lazy(() => import('@/page/Evaluation/report'))
    },
    {
        label: '测评报告-公开',
        key: 'report',
        show: true,
        path: '/public/evaluation-report',
        element: lazy(() => import('@/page/Evaluation/report'))
    },
    {
        label: '360评估登录',
        key: 'enroll',
        show: true,
        path: '/public/evaluation-enroll',
        element: lazy(() => import('@/page/EvaluationCircle/userInfo/UserInfo'))
    },
    {
        label: '360评估列表',
        key: 'list',
        show: true,
        path: '/public/evaluation-list',
        element: lazy(() => import('@/page/EvaluationCircle/list/evalList'))
    },
    {
        label: '360评估答题',
        key: 'circle',
        show: true,
        path: '/public/evaluation-circle',
        element: lazy(() => import('@/page/EvaluationCircle/questionnaire/circle'))
    }
];
export default EvaluationRoutes;
